import { apiClient, type Paginated } from '@/core/api';
import type { ReportSchedule, ReportScheduleInput } from './types';

const BASE = '/command-center/report-schedules/';

export async function listSchedules(): Promise<ReportSchedule[]> {
  const { data } = await apiClient.get<Paginated<ReportSchedule> | ReportSchedule[]>(BASE);
  return Array.isArray(data) ? data : data.results;
}

export async function createSchedule(input: ReportScheduleInput): Promise<ReportSchedule> {
  const { data } = await apiClient.post<ReportSchedule>(BASE, input);
  return data;
}

export async function deleteSchedule(id: number): Promise<void> {
  await apiClient.delete(`${BASE}${id}/`);
}
